export default __webpack_public_path__ + "78c052b46d057e3527ea122cf16a2514.png";